import styled, { css } from 'styled-components';
import { fromMd, timingSlower, zIndexForeground } from '../../constants';
import { Skeleton as LMFSkeleton } from '../Skeleton';
export const Container = styled.div `
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  position: relative;
  width: 100%;
  aspect-ratio: ${o => o.$aspectRatios && o.$aspectRatios.sm};
  ${fromMd} {
    aspect-ratio: ${o => o.$aspectRatios && o.$aspectRatios.md};
  }
`;
const baseAssetStyles = css `
  height: 100%;
  object-fit: cover;
  font-family: 'object-fit: cover;';
  position: absolute;
  top: 0;
  width: 100%;
  z-index: ${zIndexForeground - 5};
`;
export const Video = styled.video `
  ${baseAssetStyles}
`;
export const Image = styled.img `
  ${baseAssetStyles}
`;
export const Skeleton = styled(LMFSkeleton) `
  /* Hide & disable interaction with skeleton component when hiding post-load */
  opacity: ${o => o.hasLoaded && '0'};
  pointer-events: ${o => (o.hasLoaded ? 'none' : 'auto')};
  transition: opacity ${timingSlower} ease;
  animation-play-state: ${props => (props.hasLoaded ? 'paused' : 'running')};
  position: ${props => (props.isBlock ? 'relative' : 'absolute')};
  inset: ${props => (props.isBlock ? 'unset' : '0px')};

  &::after {
    content: '';
    display: block;
    padding-top: 100%;
  }

  &::after,
  &::before {
    animation-play-state: ${props => (props.hasLoaded ? 'paused' : 'running')};
  }
`;
export const VideoButtons = styled.div `
  z-index: 100;
  display: flex;
  gap: 16px;
  position: absolute;
  ${fromMd} {
    top: unset;
    bottom: 40px;
    right: 40px;
  }
  bottom: unset;
  top: 16px;
  right: 16px;
`;
//# sourceMappingURL=styles.js.map